// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://use.typekit.net/oob4opl.css);"]);
// Module
exports.push([module.id, ".Diagram {\n  margin: 0 -24px; }\n  .Diagram--scrollable {\n    overflow: scroll; }\n  .Diagram__loader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    opacity: .6; }\n  @media only screen and (max-width: 767px) {\n    .Diagram--scrollable {\n      overflow-x: hidden; } }\n", ""]);
// Exports
module.exports = exports;
